import settings from '@config';
import Action from '@lib/Action';
import getPropsBase from '@lib/getProps'

const pathConfigs = {}
export const map = ({ id, page, path }: any) => `${pathConfigs[path]}`.replace(/:id/, id).replace(/:page/, page);
export const getProps = getPropsBase(map);


export const defaultRoute = {
	...settings.route,
	action: Action.instanse(),
	webType: 'web', style: { '--button-bar-height': 0 }
};


export default pathConfigs;
